import { RefuelStringLabels } from '../../../../util/Strings';
import RefuelListTable from './RefuelListTable';
import ModuleHeader from '../../../common-components/ModuleHeader';
import { useSelector } from 'react-redux';
import { useState } from 'react';

function Refuel() {
  const data = useSelector((state) => state.refuel.refuelData);
  const isVisitCompleted = useSelector(
    (state) => state.visits.selectedVisitIsCompleted
  );

  const [showOrderModal, setShowOrderModal] = useState(false);

  return (
    <div className="events-list-container">
      <ModuleHeader
        heading={RefuelStringLabels.refuel}
        buttons={[
          {
            label: "Update Order",
            onClick: () => setShowOrderModal(true),
            show: data && data.length > 0 && !isVisitCompleted,
          },
        ]}
      />
      <div className="events-list-content">
        <RefuelListTable
          showOrderModal={showOrderModal}
          setShowOrderModal={setShowOrderModal}
        />
      </div>
    </div>
  );
}

export default Refuel;